import RPCServices from "../rpc/RPCServices";

export default class RecordLogUtils {
  public constructor() {}
  public static postLog(action: string, description: string): void {
    RPCServices.getStudioService().postLog(action, description);
  }
  public static onPressedButtonLog(path: string): void {
    RecordLogUtils.postLog("On Pressed Button", "Mouse Click, " + path);
  }
}
